"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparatorTrigger = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const Clickable_1 = require("../Clickable");
exports.ComparatorTrigger = (0, styled_1.default)(Clickable_1.Clickable)((props) => ({
    ...(0, constants_1.comparatorStyles)(props),
    width: 'auto',
    '&:hover': {
        color: constants_1.Color.CHARCOAL,
        backgroundColor: constants_1.Color.LIGHT_GREY,
    },
}));
exports.ComparatorTrigger.displayName = 'ComparatorTrigger';
